import { render, staticRenderFns } from "./ctccAuth.vue?vue&type=template&id=2bf3575c&"
import script from "./ctccAuth.vue?vue&type=script&lang=js&"
export * from "./ctccAuth.vue?vue&type=script&lang=js&"
import style0 from "./ctccAuth.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports